enum SettingKeys {
  PORTAL_FIAT_CURRENCIES_ENABLED = "PORTAL_FIAT_CURRENCIES_ENABLED",
  PORTAL_CRYPTO_CURRENCIES_ENABLED = "PORTAL_CRYPTO_CURRENCIES_ENABLED",
  PORTAL_TRANSACTION_CRYPTO_AMOUNT_BOUNDARIES = "PORTAL_TRANSACTION_CRYPTO_AMOUNT_BOUNDARIES",
  PORTAL_TRANSACTION_FIAT_AMOUNT_BOUNDARIES = "PORTAL_TRANSACTION_FIAT_AMOUNT_BOUNDARIES",
  COMPANY_INITIAL_FIAT_ACCOUNTS = "COMPANY_INITIAL_FIAT_ACCOUNTS",
  COMPANY_INITIAL_CRYPTO_ACCOUNTS = "COMPANY_INITIAL_CRYPTO_ACCOUNTS",
  COMPANY_ALLOWED_FEATURES = "COMPANY_ALLOWED_FEATURES",
  COMPANY_INITIAL_FEATURES_INDIVIDUAL = "COMPANY_INITIAL_FEATURES_INDIVIDUAL",
  COMPANY_INITIAL_FEATURES_COMPANY = "COMPANY_INITIAL_FEATURES_COMPANY",
  TRANSACTION_AUTORECALL_DEPOSIT_FROM_BLACKLISTED_AGENT = "TRANSACTION_AUTORECALL_DEPOSIT_FROM_BLACKLISTED_AGENT",
  TRANSACTION_COMPLIANCE_AUTO_APPROVE_ENABLED = "TRANSACTION_COMPLIANCE_AUTO_APPROVE_ENABLED",
  TRANSACTION_COMPLIANCE_AUTO_APPROVE_MAX_AMOUNT = "TRANSACTION_COMPLIANCE_AUTO_APPROVE_MAX_AMOUNT",
  TRANSACTION_COMPLIANCE_AUTO_APPROVE_MAX_AGE = "TRANSACTION_COMPLIANCE_AUTO_APPROVE_MAX_AGE",
  TRANSACTION_SHOW_TRANSACTIONS_FROM_LOG_DATE = "TRANSACTION_SHOW_TRANSACTIONS_FROM_LOG_DATE",
  CRYPTO_EXCHANGE_FIAT_CRYPTO_ENABLED = "CRYPTO_EXCHANGE_FIAT_CRYPTO_ENABLED",
  CRYPTO_EXCHANGE_CRYPTO_FIAT_ENABLED = "CRYPTO_EXCHANGE_CRYPTO_CRYPTO_ENABLED",
  CRYPTO_CONVERT_ENABLED = "CRYPTO_CRYPTO_CONVERT_ENABLED",
}

export { SettingKeys };
